import { zodResolver } from "@hookform/resolvers/zod";
import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { useReminderUpdateMutation } from "web_myplann/Api/Reminders/useReminderUpdateMutation";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import {
	getReminderFormSchema,
	mapReminderToFormModel,
	type ReminderFormModel,
} from "web_myplann/Reminders/Forms/reminderFormSchema";
import type { Reminder } from "web_myplann/Reminders/Types/ReminderTypes";

type UseReminderEditFormProps = {
	reminder: Reminder;
	onSuccess: () => void;
};

export const useReminderEditForm = ({
	reminder,
	onSuccess,
}: UseReminderEditFormProps) => {
	const { t } = useResource();
	const { mutate: updateReminder, isPending } = useReminderUpdateMutation();

	const resolver = useMemo(
		() => zodResolver(getReminderFormSchema(t, reminder.date)),
		[t, reminder.date],
	);

	const form = useForm<ReminderFormModel>({
		resolver,
		mode: "onChange",
		defaultValues: mapReminderToFormModel(reminder),
	});

	const submit = form.handleSubmit((model) => {
		updateReminder({ id: reminder.id, model }, { onSuccess });
	});

	return {
		form,
		submit,
		isSubmitting: isPending,
	};
};
